export default {
  titleAllProducts: {
    id: 'reviews_page_all_products_title',
    defaultMessage: 'Customer reviews for all refurbished products',
  },
  titleMerchantProducts: {
    id: 'reviews_page_merchant_products_title',
    defaultMessage: "{merchant}'s customer reviews",
  },
  titlePlaceholder: {
    id: 'reviews_page_title_placeholder',
    defaultMessage: 'Customer reviews',
  },
} as const
